import type {JSONSchema7} from 'json-schema';
import {FC} from 'react';
import {Form} from 'semantic-ui-react';
import {every, flatMap, isObject, map, uniqBy, values} from 'lodash';
import {set} from 'lodash/fp';
import {Field, ValueInput, ValueRenderer, ValueInputRendererProps} from 'apstra-ui-common';

import humanizeString from '../../humanizeString';

import './SystemHealthThresholdInput.less';

const SystemHealthThresholdInput: FC<ValueInputRendererProps> = ({
  name, value, schema, required, disabled, errors, onChange, fieldProps
}) => {
  const headerSchemas = uniqBy(
    flatMap(schema!.properties, (property) => values((property as JSONSchema7).properties) as JSONSchema7[]),
    'title'
  );
  return (
    <Field
      className='multi-items-input system-health-threshold-input'
      label={schema?.title ?? name}
      description={schema?.description}
      required={required}
      disabled={disabled}
      errors={errors}
      {...fieldProps}
    >
      <Field className='field-subheader'>
        <Form.Group>
          <Field width={4} label='System Type' />
          {map(headerSchemas, ({description, title}, index) =>
            <Field key={index} width={4} label={title} description={description} descriptionPosition='tooltip' />
          )}
        </Form.Group>
      </Field>
      {map(schema!.properties, (systemTypeProperties, systemType) =>
        <Form.Group key={systemType}>
          <Field className='system-type' width={4}><span>{humanizeString(systemType)}</span></Field>
          {map(
            (systemTypeProperties as JSONSchema7).properties,
            (propSchema: JSONSchema7, propName) => (
              <ValueInput
                key={propName}
                schema={propSchema}
                value={value?.[systemType]?.[propName]}
                onChange={(newValue: any) => {
                  onChange(set([systemType, propName], newValue, value));
                }}
                fieldProps={{description: '', label: '', width: 4}}
              />
            )
          )}
        </Form.Group>
      )}
    </Field>
  );
};

export default SystemHealthThresholdInput;

export const systemHealthThresholdsRenderer = new ValueRenderer({
  condition: ({name = '', schema}) =>
    name === 'thresholds' && schema?.type === 'object' &&
    every(schema.properties, (property) => isObject(property) && property.type === 'object'),
  ValueInput: SystemHealthThresholdInput
});
